import { STANDARD_NUMBER_HEIGHT, STANDARD_NUMBER_WIDTH } from '@Animation/constants'
import { KENO_SNAKES_ATLAS_FRAMES, KENO_SNAKES_TEXTURE_KEYS } from './constants'

export const KenoSnakeTexturePreloader = (scene: Phaser.Scene) => {
  if (!scene.textures.getTextureKeys().includes(KENO_SNAKES_TEXTURE_KEYS.NUMBER_DEFAULT)) {
    scene.textures.addSpriteSheetFromAtlas(KENO_SNAKES_TEXTURE_KEYS.NUMBER_DEFAULT, {
      atlas: KENO_SNAKES_TEXTURE_KEYS.ATLAS,
      frame: KENO_SNAKES_ATLAS_FRAMES.NUMBER_DEFAULT,
      frameWidth: STANDARD_NUMBER_WIDTH,
      frameHeight: STANDARD_NUMBER_HEIGHT,
    })
  }

  if (!scene.textures.getTextureKeys().includes(KENO_SNAKES_TEXTURE_KEYS.NUMBER_SYSTEM_SELECTED)) {
    scene.textures.addSpriteSheetFromAtlas(KENO_SNAKES_TEXTURE_KEYS.NUMBER_SYSTEM_SELECTED, {
      atlas: KENO_SNAKES_TEXTURE_KEYS.ATLAS,
      frame: KENO_SNAKES_ATLAS_FRAMES.NUMBER_SYSTEM_SELECTED,
      frameWidth: STANDARD_NUMBER_WIDTH,
      frameHeight: STANDARD_NUMBER_HEIGHT,
    })
  }

  if (!scene.textures.getTextureKeys().includes(KENO_SNAKES_TEXTURE_KEYS.NUMBER_PLAYER_SELECTED)) {
    scene.textures.addSpriteSheetFromAtlas(KENO_SNAKES_TEXTURE_KEYS.NUMBER_PLAYER_SELECTED, {
      atlas: KENO_SNAKES_TEXTURE_KEYS.ATLAS,
      frame: KENO_SNAKES_ATLAS_FRAMES.NUMBER_PLAYER_SELECTED,
      frameWidth: STANDARD_NUMBER_WIDTH,
      frameHeight: STANDARD_NUMBER_HEIGHT,
    })
  }

  if (!scene.textures.getTextureKeys().includes(KENO_SNAKES_TEXTURE_KEYS.NUMBER_HIT)) {
    scene.textures.addSpriteSheetFromAtlas(KENO_SNAKES_TEXTURE_KEYS.NUMBER_HIT, {
      atlas: KENO_SNAKES_TEXTURE_KEYS.ATLAS,
      frame: KENO_SNAKES_ATLAS_FRAMES.NUMBER_HIT,
      frameWidth: STANDARD_NUMBER_WIDTH,
      frameHeight: STANDARD_NUMBER_HEIGHT,
    })
  }
}
